import React from 'react';
import { Globe } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';

const LanguageToggle = ({ className = '' }) => {
  const { language, toggleLanguage } = useLanguage();

  const defaultClasses = "flex items-center gap-2 px-3 py-2 rounded-lg transition-colors";
  const baseClasses = className || "bg-gray-100 hover:bg-gray-200 text-gray-700 hover:text-gray-900";

  return (
    <button
      onClick={toggleLanguage}
      className={`${defaultClasses} ${baseClasses}`}
      title={language === 'fa' ? 'Switch to English' : 'تغییر به فارسی'}
    >
      <Globe className="w-4 h-4" />
      <span className="text-sm font-medium">
        {language === 'fa' ? 'EN' : 'فا'}
      </span>
    </button>
  );
};

export default LanguageToggle;